import URLJS from "urijs";

export const PORTAL_BASE_URL = process.env.REACT_APP_PORTAL_BASE_URL;

export const rebuildQuery = (queries: {
  [key: string]: string | string[] | undefined;
}) => {
  let url = new URLJS(window.location.pathname + window.location.search);
  Object.keys(queries).forEach((k) => {
    const v = queries[k];
    if (!!v) {
      if (typeof v === "string") {
        url = url.setQuery(k, v);
      } else {
        url = url.setQuery(k, JSON.stringify(v));
      }
    } else {
      url = url.removeQuery(k);
    }
  });
  return url.toString();
};
